import {H2} from '@jetbrains/ring-ui/components/heading/heading'
import {memo, Suspense, useMemo} from 'react'

import TransformText from '../../../../../../containers/TransformText'
import {useIsAutodetectTimeZone} from '../../../../../../hooks/useIsAutodetectTimeZone'
import type {BuildTypeId, ChangeId} from '../../../../../../types'
import {displayDate} from '../../../../../../utils/dateTimeUtils'
import ActionsDropdown from '../../../../../common/ActionsDropdown/ActionsDropdown.container'
import {getChangeExtensionsPath} from '../../../../../common/InjectExtensions/InjectExtensions.utils'
import UncommitedChangeLabel from '../../../../../common/UncommitedChangeLabel/UncommitedChangeLabel'
import ChangeAuthor from '../../../ChangeAuthor/ChangeAuthor'
import {getChange} from '../../../Changes.selectors'

import styles from './ChangesDetailsPopupHeader.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  className?: string
  buildTypeId: BuildTypeId | null | undefined
  changeId: ChangeId
}

function ChangesDetailsPopupHeader({className, buildTypeId, changeId}: Props) {
  const change = useAppSelector(state => getChange(state, changeId))
  const isAutodetectTimeZone = useIsAutodetectTimeZone()

  const {comment, personal, date} = change ?? {}
  const actionsEntityHref = getChangeExtensionsPath({changeId, buildTypeId, personal})
  const heading = useMemo(
    () => (
      <H2 className={styles.title}>
        {'Change'}
        <ActionsDropdown entityHref={actionsEntityHref} compact preload />
      </H2>
    ),
    [actionsEntityHref],
  )
  return (
    <div className={className}>
      <div className={styles.header}>
        {heading}
        <div>
          <Suspense>
            <ChangeAuthor changeId={changeId} withAvatar />
          </Suspense>
          {date != null && (
            <span className={styles.datetime}>
              {`at ${displayDate(date, isAutodetectTimeZone, true)}`}
            </span>
          )}
        </div>
      </div>
      <div className={styles.subheader}>
        {personal === true && (
          <UncommitedChangeLabel iconClassName={styles.personalIcon} onlyIcon />
        )}
        <TransformText
          className={styles.comment}
          buildTypeId={buildTypeId}
          text={comment != null && comment !== '' ? comment : 'No comment'}
        />
      </div>
    </div>
  )
}

export default memo(ChangesDetailsPopupHeader)
